/**
 * Seletor de conta do Instagram, para telas que agem em nome de UMA conta.
 *
 * Com uma conta só ele não aparece: a tela se comporta como antes da
 * multi-conta, sem um controle a mais que não decide nada.
 */

import { trpc } from "@/lib/trpc";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TODAS = "todas";

export function useInstagramAccounts() {
  return trpc.instagram.account.options.useQuery(undefined, { staleTime: 60_000 });
}

export function rotuloConta(c: { username: string | null; name: string | null; igUserId: string }) {
  return c.username ? `@${c.username}` : (c.name ?? c.igUserId);
}

export default function InstagramAccountSelect({
  value,
  onChange,
  permitirTodas = false,
  className,
}: {
  value: number | null;
  onChange: (id: number | null) => void;
  /** Mostra "Todas as contas" (filtros). Sem isso, a escolha é obrigatória. */
  permitirTodas?: boolean;
  className?: string;
}) {
  const contas = useInstagramAccounts();
  const lista = contas.data ?? [];
  if (lista.length <= 1) return null;

  return (
    <Select
      value={value == null ? (permitirTodas ? TODAS : "") : String(value)}
      onValueChange={(v) => onChange(v === TODAS ? null : Number(v))}
    >
      <SelectTrigger className={className ?? "w-[220px]"} aria-label="Conta do Instagram">
        <SelectValue placeholder="Escolha a conta" />
      </SelectTrigger>
      <SelectContent>
        {permitirTodas && <SelectItem value={TODAS}>Todas as contas</SelectItem>}
        {lista.map((c) => (
          <SelectItem key={c.id} value={String(c.id)}>
            {rotuloConta(c)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
